import {
  localeFormatter, preFormatter, prevEventsFormatter, tooltipFormatter,
} from '../../../utils/formatters';
import { projectMoment } from '../../../utils/projectTime';

export const vehiclesColumns = [
  {
    dataField: 'device_id',
    text: 'device_id',
    disableSort: true,
    headerClassName: 'mv-150',
    formatter: tooltipFormatter,
  },
  {
    dataField: 'vehicle_id',
    text: 'ИД ТС',
    disableSort: true,
    headerClassName: 'mv-150',
    formatter: tooltipFormatter,
  },
  {
    dataField: 'provider_name',
    text: 'vehicles.provider_id',
    headerClassName: 'mv-200',
    disableSort: true,
    formatter: t => (t || ''),
  },
  {
    dataField: 'vehicle_type',
    text: 'vehicles.vehicle_type',
    headerClassName: 'mv-200',
    disableSort: true,
    formatter: t => (t ? localeFormatter('vehicle.types', t) : ''),
  },
  {
    dataField: 'propulsion_types',
    text: 'rules.propulsion_types',
    headerClassName: 'mv-200',
    disableSort: true,
    formatter: t => (t || []).map(vt => localeFormatter('propulsion.types', vt)).join(', '),
  },
  {
    dataField: 'year',
    text: 'vehicles.year',
    disableSort: true,
  },
  {
    dataField: 'mfgr',
    text: 'vehicles.mfgr',
    disableSort: true,
  },
  {
    dataField: 'model',
    text: 'vehicles.model',
    disableSort: true,
  },
  {
    dataField: 'state',
    text: 'vehicles.state',
    headerClassName: 'mv-200',
    disableSort: true,
    formatter: t => (t ? localeFormatter('vehicle.state', t) : ''),
  },
  {
    dataField: 'prev_events',
    text: 'vehicles.prev_events',
    headerClassName: 'mv-300',
    disableSort: true,
    formatter: prevEventsFormatter,
  },
  {
    dataField: 'updated',
    text: 'vehicles.updated',
    disableSort: true,
    formatter: t => (t ? projectMoment(t).format('YYYY-MM-DD HH:mm:ss') : ''),
  },
];

export const vehiclesAdditionalColumns = [];
